import axios from 'axios'

import { COP_COMMON_ERROR_MESSAGES } from '../constants/common-error-messages'
import { AGREEMENTS_LIST_ENDPOINT,COP_API_BASE_URL } from '../constants/service-endpoints'
import { ToastService } from './toast.service'
import { buildCopHeaders,getSilentToken } from './tokenUtils'

export interface AgreementListParams {
  top?: number
  skip?: number
  orderby?: string
  count?: boolean
  filter?: string
}

export interface Agreement {
  customerId: string
  id: string
  number: string
  validFrom: string
  validTo: string
  status: 'active' | 'warning' | 'inactive'
  legalEntityName: string
}

export interface AgreementListResponse {
  '@odata.count'?: number
  value: Agreement[]
}

function buildFilterExpression(search: string): string {
  const escaped = search.replace(/'/g, "''")
  const lower = escaped.toLowerCase()
  const statusParts: string[] = []
  if (lower.length > 0 && 'active'.startsWith(lower)) statusParts.push(`(status eq 'Active')`)
  if (lower.length > 0 && 'inactive'.startsWith(lower)) statusParts.push(`(status eq 'Inactive')`)
  const statusFilter = statusParts.length > 0 ? ` or ${statusParts.join(' or ')}` : ''
  return `((contains(legalEntityName,'${escaped}')) or (contains(number,'${escaped}'))${statusFilter})`
}

function buildODataQuery(params: Required<AgreementListParams>): string {
  const query = new URLSearchParams()
  query.set('$orderby', params.orderby)
  query.set('$count', String(params.count))
  query.set('$top', String(params.top))
  query.set('$skip', String(params.skip))
  if (params.filter) {
    query.set('$filter', buildFilterExpression(params.filter))
  }
  return `?${query.toString()}`
}

export async function fetchAgreements(
  params: AgreementListParams = {},
): Promise<AgreementListResponse | null> {
  const {
    top = 10,
    skip = 0,
    orderby = 'validTo asc',
    count = true,
    filter = '',
  } = params

  try {
    const token = getSilentToken();
    const url = `${COP_API_BASE_URL}${AGREEMENTS_LIST_ENDPOINT}${buildODataQuery({ top, skip, orderby, count, filter })}`
    const headers = buildCopHeaders(token)

    const response = await axios.get<AgreementListResponse>(url, { headers })
    const { '@odata.count': odataCount, value } = response.data
    return { '@odata.count': odataCount, value }
  } catch (error) {
    const fallbackMessage = COP_COMMON_ERROR_MESSAGES['api-error'].message.replace(
      '{{action}}',
      COP_COMMON_ERROR_MESSAGES['api-error'].action['agreements-loading'],
    )
    const message = error instanceof Error && error.message ? error.message : fallbackMessage
    ToastService.error(message)
    return null
  }
}

